module.exports = __webpack_public_path__ + "static/media/canecas.3a827b28.jpg";